import {HttpServices} from '../Helpers';

export const GetEmployeePersonalData = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/employees/${
            process.env.REACT_APP_VERSION_API
        }/employee/view?uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeJobExperience = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/employees/${
            process.env.REACT_APP_VERSION_API
        }/employee/job-experience?employee_uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeEducation = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/employees/${
            process.env.REACT_APP_VERSION_API
        }/employee/education?employee_uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeCompetency = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/employees/${
            process.env.REACT_APP_VERSION_API
        }/employee/competency?uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeAddress = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/employees/${
            process.env.REACT_APP_VERSION_API
        }/employee/address?uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeCertificate = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/employees/${
            process.env.REACT_APP_VERSION_API
        }/employee/certificate?uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeDocument = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/employees/${
            process.env.REACT_APP_VERSION_API
        }/employee/document?uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeRelative = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/employees/${
            process.env.REACT_APP_VERSION_API
        }/employee/relative?uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeAcademicSkills = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/setup/${
            process.env.REACT_APP_VERSION_API
        }/personnel/academic-skill?uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetEmployeeLanguageProficiency = async (employee_uuid) => {
    const result = await HttpServices.get(
        `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/${
            process.env.REACT_APP_VERSION_API
        }/service/language_proficiency?uuid=${employee_uuid}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};
